module.exports = __webpack_public_path__ + "static/media/TitlingGothicFBComp-Medium.f7144f86.woff";